import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { BusquedaCpa0, BusquedaCpa1 } from './steps'
import { FORM_BUSQUEDACPA } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import { busquedaCpa, finalizarBusquedaCpa } from '../../actions'

function BusquedaCpa (props) {
  const { busquedaCpaStep } = props

  const nextStep = () => {
    props.busquedaCpa()
  }

  const finalizarConsulta = () => {
    props.finalizarBusquedaCpa(props.destroy)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      {busquedaCpaStep === 0 && <>
        <h2>Búsqueda de carta de porte automotor</h2>
        <BusquedaCpa0 onSubmit={nextStep} />
        </>
      }
      {busquedaCpaStep === 1 && <BusquedaCpa1 handleClose={finalizarConsulta} /> }
    </>
  )
}

const selector = formValueSelector(FORM_BUSQUEDACPA)

const mapStateToProps = (state) => {
  return {
    busquedaCpaStep: state.camionesIngreso.busquedaCpaStep,
    numero: selector(state, 'numero')
  }
}

const mapActionsToProps = ({
  busquedaCpa,
  finalizarBusquedaCpa
})

const withReduxForm = reduxForm({
  form: FORM_BUSQUEDACPA
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(BusquedaCpa))
